var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left text-sm-center w-100 w-sm-75 d-flex flex-column align-items-start align-items-sm-center",class:[
    { 'order-3' : _vm.isDesktop },
    { 'order-5' : _vm.isMobile },
  ]},[_c('span',{staticClass:"font-weight-600 mb-2"},[_vm._v("Helpfull Tip:")]),_c('span',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }